export default __webpack_public_path__ + "static/media/to.9aa405e1.jpg";